import { Divider, Stack } from "@mui/material";
import { ESRSurveyRequest } from "../../types/data";

type Props = {
	esr: Pick<ESRSurveyRequest, "id" | "identifiers" | "sponsor_type">;
};

export function ESRSummary({ esr }: Props) {
	return (
		<Stack
			direction="row"
			sx={{
				height: 14,
				my: "8px",
				alignItems: "center",
				color: "#00000099",
				fontSize: 14,
			}}
		>
			Sponsor Type: {esr.sponsor_type || "-"}
			{esr.sponsor_type === "Local" && (
				<>
					<Divider orientation="vertical" sx={{ mx: "8px" }} />
					Section #{esr?.identifiers?.section_no ?? "-"}
				</>
			)}
			{esr.sponsor_type === "State" && (
				<>
					<Divider orientation="vertical" sx={{ mx: "8px" }} />
					Contract #{esr?.identifiers?.contract_no ?? "-"}
				</>
			)}
			{esr.identifiers !== null && (
				<>
					<Divider orientation="vertical" sx={{ mx: "8px" }} />
					Counties: {esr?.identifiers?.counties ?? "-"}
					<Divider orientation="vertical" sx={{ mx: "8px" }} />
					Route: {esr?.identifiers?.route ?? "-"}
				</>
			)}
			{/*<Divider orientation="vertical" sx={{ mx: "8px" }}/>*/}
			{/*Section No. {esr.identifiers.section_no || 'N/A'}*/}
		</Stack>
	);
}